import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["strategyId", "label"];
import I18n from 'I18n';
import { Button } from 'foundations-components/transitional/components/Button';
import withUsageTracking from 'personalization-lib/components/shared/hocs/withUsageTracking';
import withInlineErrorHandling from 'personalization-lib/components/shared/hocs/withInlineErrorHandling';
import useButtonClickTracker from 'personalization-lib/hooks/tracking/library/useButtonClickTracker';
import { getVariantsEditorUrl } from 'personalization-lib/utils/urls/personalization';
import { jsx as _jsx } from "react/jsx-runtime";
const PersonalizationLink = _ref => {
  let {
      strategyId,
      label
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const trackButtonClick = useButtonClickTracker();
  return /*#__PURE__*/_jsx(Button, Object.assign({
    href: getVariantsEditorUrl(strategyId),
    onClick: trackButtonClick.backToPersonalization,
    "data-test-id": "personalization-link"
  }, props, {
    children: label !== null && label !== void 0 ? label : I18n.text('personalizationLib.buttons.personalizationLink.label')
  }));
};
export default withInlineErrorHandling(withUsageTracking(PersonalizationLink));